import core from '@gin-betting/core';
import 'root/cms-mock/initScript'; // Don't remove. NOTE: initScript should be init at first !
import 'services/locale-manager'; // Don't remove. NOTE: LocaleManager should be init at first !
import 'timing.js';

import UserDevice from 'services/user-device';
import getBettingAPI from './root/getBettingAPI';
import adaptBettingOptions from './utils/adaptBettingOptions';

import './global.scss';
import './styles/sizes.scss';

const {
    utils: { getBettingOptions },
} = core;

window.__app = window.__app || ({} as AppPublicAPI);
window.__app.timings = {};

init();

if (__DEV__) {
    let disabledHeader: HTMLElement | null = null;
    let enabledHeader: HTMLElement | null = null;

    if (UserDevice.getInstance()?.isDeviceMobile()) {
        disabledHeader = document.getElementById('header');
        enabledHeader = document.getElementById('mobile-header');
    } else {
        disabledHeader = document.getElementById('mobile-header');
        enabledHeader = document.getElementById('header');
    }

    if (disabledHeader) {
        disabledHeader.style.display = 'none';
    }

    if (enabledHeader) {
        enabledHeader.style.display = 'block';
    }
}

function init() {
    // @ts-ignore
    window.bettingOptions = adaptBettingOptions(window.bettingOptions);

    const bettingAPI = getBettingAPI();
    // @ts-ignore
    window.bettingAPI = bettingAPI;

    UserDevice.init();

    if (__DEV__) {
        window.bettingLoader = {
            __getLocale: require('./getLocaleByCMSLocale').default(
                getBettingOptions().locale
            ),
        } as any;
        // @ts-ignore
        // bettingAPI.setupBreakpoints({
        //     medium: 900,
        // });
        // bettingAPI.setupWidget(BettingWidgets.BETSLIP_SIDEBAR, {
        //     containerElementId: 'betslip',
        //     isOpen: true,
        //     canToggle: true,
        // });
        // bettingAPI.setupWidget(BettingWidgets.CATEGORIZER, {
        //     containerElementId: 'categorizer',
        // });

        // @ts-ignore
        window.bettingAPI.enableAnalytics(true);
        // @ts-ignore
        window.bettingAPI.subscribe('redirect', ({ destination, link }) => {
            switch (destination) {
                case 'mix-sports':
                case 'esport':
                case 'sport':
                default: {
                    // console.log({ destination, link });
                }
            }
        });

        return bettingAPI.init();
    }

    window.bettingLoader?.__publishBettingAPI(bettingAPI);
}

// function setupSentry() {
//     const bettingOptions = getBettingOptions();

//     if (
//         !bettingOptions ||
//         __DEV__ ||
//         location.hostname.includes('stage') ||
//         location.hostname.includes('dev.') || // cv stage
//         location.hostname.includes('cv.staging') // cv stage
//     ) {
//         return;
//     }

//     const { locale, currency, token, isAuthorized, url } = bettingOptions;

//     sentryHub.setClient({
//         dsn: 'https://2c0fef52363e4a778cd5399f9ecded0f@sentry.io/297300',
//         release: __SENTRY_RELEASE__,
//         environment: 'production',
//         sampleRate: 0.1,
//         maxBreadcrumbs: 20,
//         enabled: true,
//         ignoreErrors: [
//             'top.GLOBALS',
//             'originalCreateNotification',
//             'canvas.contentDocument',
//             'fb_xd_fragment',
//             'Failed to fetch',
//             'NetworkError when attempting to fetch resource.',
//             'A batched Operation of responses for',
//             'window.dohander.getBody',
//             'window.dor.by',
//             'AbortError',
//             'player.twitch.tv',
//         ],
//         blacklistUrls: [
//             /\/(gtm|ga|analytics)\.js/i,
//             /extensions\//i,
//             /^chrome:\/\//i,
//             /mobile-build.js/i,
//             /mobile_main_user/i,
//         ],
//     });

//     sentryHub.setTags({
//         locale,
//         currency,
//         authorized: isAuthorized ? 'true' : 'false',
//         version: __VERSION__,
//     });

//     sentryHub.setExtras({
//         token,
//         pagePath: url.pagePath,
//         timings: window.__app.timings,
//     });
// }
